import { makeStyles } from "@mui/styles";
import { SURVEY_COLORS } from "../../../shared/theme-constants";
import { getSharedStyles } from "../../../shared/shared-styles";

interface TrainingNeedsAnalysisStylesProps {
  isMobile: boolean;
}

export const useStyles = makeStyles((theme) => ({
  "@global": {
    ".k-popup": {
      zIndex: "99999 !important",
    },
    ".k-popup.k-popup-transparent": {
      zIndex: "99999 !important",
    },
    ".k-calendar": {
      zIndex: "99999 !important",
    },
    ".k-animation-container": {
      zIndex: "99999 !important",
    },
  },
  ...getSharedStyles(theme),
  headerDescription: {
    fontSize: "16px",
    color: SURVEY_COLORS.TEXT_SECONDARY,
    marginBottom: "16px",
    textAlign: "center",
  },
  cardTitle: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "24px",
  },
  questionItem: {
    marginBottom: "32px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    justifyContent: "space-between",
    marginTop: "24px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  contentCard: {
    backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
    borderRadius: "8px",
    padding: "24px",
    marginBottom: "16px",
    boxShadow: SURVEY_COLORS.BOX_SHADOW,
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: (props: TrainingNeedsAnalysisStylesProps) =>
      props.isMobile ? "none" : "calc(90vh - 300px)",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "none",
      padding: "16px",
    },
  },
}));
